


















import { Vue, Component } from "vue-property-decorator";
import axios from "axios";
import Todo from "./Todo.vue";
import {DataModel, RootObjectModel, initilizedDataModel, initilizedRootObjectModel} from  '../Interfaces/TodosModel';

@Component({
    components: {
        Todo
    }
})
export default class Todos extends Vue {
    private errorMessage = "";
    private todos: DataModel = initilizedDataModel;
    private dataSet: RootObjectModel = initilizedRootObjectModel;
    private selectedTodoId = 0;
    $store: any;

    created() {
        this.fetchTodos();
        this.singleView = true;
    }

    get singleView(): boolean {
        return this.$store.state.todos.todosLoaded;
    }

    set singleView(newVal: boolean) {
        this.$store.state.todos.todosLoaded = newVal;
    }


   async fetchTodos() {
       await axios
            .get("/api/todos")
            .then(({ data }) => {
                this.dataSet = data;
                this.todos = data.data;
            })
            .catch(() => {
                this.errorMessage = "Sorry we are having problem fetching data";
            });
    }

    SelectedTodId(todoId: number): void {
        this.selectedTodoId = todoId;
        this.singleView = false;
    }
}
